module.exports = __webpack_public_path__ + "static/Cat-f7926894a1210b68f426d08894756956.jpg";